import underscore from 'underscore';

export function hasAnyValueMatch(event, targets) {
  if (!event?.length) return false;

  const values = new Set(underscore.pluck(event, 'value'));
  return targets.some((target) => values.has(target));
}
